<template>
  <div class="scroll-div" v-loading="loadingReply">
    <div class="page-header-class padding10px">
      <el-button type="text" icon="el-icon-d-arrow-left" @click="close">返回</el-button>
      <template v-if="isEmail">
        <el-button type="primary" @click="setContent">回复</el-button>
        <el-button type="primary" @click="translation">翻译</el-button>
        <el-select v-model="langObj.from" clearable filterable placeholder="源语言选择"
          style="width: 130px; margin-left: 10px">
          <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
            :key="i"></el-option>
        </el-select>
        <span class="toText-css">
          <i class="el-icon-sort" :style="{ color: tabcolors }"></i>
        </span>
        <el-select v-model="langObj.to" clearable filterable placeholder="目标语言选择"
          style="width: 130px; margin-right: 10px">
          <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
            :key="i"></el-option>
        </el-select>
        <el-button type="warning" @click="markMail">标记邮件</el-button>
        <el-select v-model="mailTxt" clearable filterable placeholder="请选择" style="width: 130px; margin-left: 10px">
          <el-option v-for="(val, i) in mailType" :label="val.name" :value="val.key" :key="i"></el-option>
        </el-select>
        <el-select v-model="mailTitle" clearable filterable placeholder="---历史邮件查询------"
          style="width: 380px; margin-left: 10px" @change="setMailDetail">
          <el-option v-for="(val, i) in MailList" :label="val.title" :value="val.id" :key="i"></el-option>
        </el-select>
      </template>
    </div>

    <div class="replay-div" v-loading="loading">
      <!-- 邮件详情 -->
      <div class="mail-detail">
        <div ref="message" class="border-box">
          <h2>{{ mailObj.subject }}</h2>
          <h4>发件人：{{ mailObj.sender }}</h4>
          <h4>收件人：{{ mailObj.recipients }}</h4>
          <h4>收件时间：{{ mailObj.sendDate }}</h4>
        </div>
        <div class="border-box" v-html="mailObj.htmlText || mailObj.contentText"></div>
        <div class="border-box" v-show="mailImg.length > 0 || mailPdf.length > 0">
          <p style="font-size: 14px; font-weight: bold; margin-bottom: 10px">
            <i class="el-icon-paperclip"></i>附件
          </p>
          <div v-show="mailImg.length > 0">
            <viewer style="display: flex" :images="mailImg">
              <!-- :src="src.split(':')[1]" -->
              <img v-for="(src, i) in mailImg" :src="src" :key="i" style="
                  width: 60px;
                  height: 60px;
                  margin-left: 10px;
                  cursor: pointer;
                " />
            </viewer>
          </div>
          <div v-show="mailPdf.length > 0">
            <!-- <span> 其他：</span> -->
            <el-tag style="margin-left: 20px; margin-bottom: 10px; cursor: pointer" :key="index"
              v-for="(item, index) in mailPdf" size="medium" :disable-transitions="false" @click="toTab(item)">
              <i class="el-icon-document"></i>
              <span>{{ item.attachmentName }}</span>
            </el-tag>
          </div>
        </div>
        <div v-if="isEmail">
          <el-form :model="dataObj" :rules="rules" size="small" ref="ruleForm" label-position="right" label-width="110px"
            style="margin-top: 20px">
            <template v-if="isShow">
              <el-form-item label="邮件主题" prop="subject">
                <!-- <el-input
                  v-model="dataObj.title"
                  placeholder="请输入"
                  class="input-width-two"
                  @input="setIntoStorage"
                ></el-input> -->
                <el-autocomplete style="width: 800px" v-model="dataObj.title" :fetch-suggestions="querySearch"
                  placeholder="请输入内容" :trigger-on-focus="false" @change="setIntoStorage" clearable></el-autocomplete>
              </el-form-item>
              <el-form-item label="收件人" prop="recipientAddress">
                <el-input v-model="dataObj.recipientAddress" placeholder="请输入" class="input-width-two"></el-input>
              </el-form-item>
              <el-form-item label="模板选择" prop="templateId">
                <el-select v-model="dataObj.templateId" clearable filterable placeholder="请选择" class="input-width-two"
                  @change="changeTemplate">
                  <el-option v-for="(val, key, i) in templateList" :label="val" :value="val" :key="i"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label-width="0px">
                <!-- 富文本编辑器 -->
                <div style="display: flex">
                  <el-form-item label="正文" prop="content">
                    <div style="height: 452px">
                      <quill-editor style="height: 370px" v-model="dataObj.content" ref="myQuillEditor" class="editor"
                        :options="myQuillEditor">
                      </quill-editor>
                    </div>
                  </el-form-item>
                  <div style="width: 130px; margin-left: 12px">
                    <el-select v-model="langObj.from" clearable filterable placeholder="源语言选择" style="width: 130px">
                      <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                        :key="i"></el-option>
                    </el-select>
                    <div class="sort-css" @click="changeSort()">
                      <i class="el-icon-sort" :style="{ color: tabcolors }"></i>
                    </div>
                    <el-select v-model="langObj.to" clearable filterable placeholder="目标语言选择" style="width: 130px">
                      <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                        :key="i"></el-option>
                    </el-select>

                    <el-button type="primary" style="width: 130px; height: 35px; margin-top: 12px"
                      @click="translation">翻译</el-button>
                  </div>
                </div>
              </el-form-item>
              <!-- <div style="padding: 44px"></div> -->
              <el-form-item label="备注" prop="remark">
                <el-input v-model="dataObj.remark" placeholder="请输入" :rows="2" type="textarea"
                  style="width: 60%"></el-input>
                <!-- <el-button
                style="margin-left: 15px"
                type="primary"
                @click="saveRemark()"
                >保存备注</el-button
              > -->
              </el-form-item>
              <el-form-item>
                <el-checkbox v-model="checked" style="margin-top: 6px; margin-right: 20px">设置为模板</el-checkbox>
                <template v-if="checked == 1">
                  <el-select v-model="dataObj.temLanguages" clearable filterable placeholder="请选择模板语种"
                    style="width: 200px; margin-right: 10px">
                    <el-option v-for="(val, key, i) in dropList.TemplateLanguages" :label="val" :value="key"
                      :key="i"></el-option>
                  </el-select>
                  <el-select v-model="dataObj.temType" clearable filterable placeholder="请选择模板类型" style="width: 200px">
                    <el-option v-for="(val, key, i) in dropList.TemplateType" :label="val" :value="key"
                      :key="i"></el-option>
                  </el-select>
                </template>
              </el-form-item>
              <el-form-item>
                <div class="table-header">
                  <el-button type="primary" @click="send()">发送</el-button>
                  <el-button type="primary" style="margin-left: 20px" @click="saveSlide()">存为草稿</el-button>
                  <upload buttonName="上传附件" :url="url" :param="uploadObj" style="margin-left: 20px" :text="''"
                    @getImgName="getImgName" @getImgSrc="getImgSrc" :accept="'.jpg,.jpeg,.png,.pdf'"></upload>
                </div>
              </el-form-item>
              <div style="margin-left: 90px">
                <!-- 图片 -->
                <el-tag class="tag-annex" v-show="imgName.length > 0" v-for="(item, index) in imgName" :key="index"
                  closable size="medium" :disable-transitions="false" @close="handleDel(index, item)"
                  @click="seeImg(index)">
                  <i class="el-icon-picture-outline"></i>
                  <span>{{ item.fileList }}</span>
                </el-tag>
                <!-- pdf -->
                <el-tag class="tag-annex" v-show="pdfSrc.length > 0" v-for="(item, index) in pdfSrc" :key="index" closable
                  size="medium" :disable-transitions="false" @close="handleDelPdf(index)" @click="seePdf(item)">
                  <i class="el-icon-document"></i>
                  <span>{{ item.fileList }}</span>
                </el-tag>
              </div>
            </template>
            <!-- 翻译 -->
            <div v-if="!isShow">
              <el-form-item label-width="60px">
                <el-select v-model="langObj.from" clearable filterable placeholder="源语言选择" style="width: 130px">
                  <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                    :key="i"></el-option>
                </el-select>
                <span class="toText-css" @click="changeSort()">
                  <i class="el-icon-sort" :style="{ color: tabcolors }"></i>
                </span>
                <el-select v-model="langObj.to" clearable filterable placeholder="目标语言选择"
                  style="width: 130px; margin-right: 12px">
                  <el-option v-for="(val, i) in languageArr" :label="val.languageName" :value="val.languageCode"
                    :key="i"></el-option>
                </el-select>
                <el-button type="primary" style="width: 130px; height: 35px" @click="translateClick">翻译</el-button>
                <el-button type="primary" style="width: 130px; height: 35px" @click="translation">写入正文</el-button>
              </el-form-item>
              <div style="display: flex">
                <div style="width: 50%">
                  <el-form-item label="正文：" label-width="60px">
                    <el-input ref="textInput" type="textarea" v-model="langObj.query" :rows="12"></el-input>
                  </el-form-item>
                </div>
                <div style="width: 50%">
                  <el-form-item label="译文：" label-width="60px">
                    <el-input type="textarea" v-model="newText" :rows="12"></el-input>
                  </el-form-item>
                </div>
              </div>
            </div>
          </el-form>
        </div>
      </div>
      <!-- 订单信息 客户邮件显示-->
      <div class="order-box" v-if="scope.mailType == 9 || scope.mailType == 3" v-loading="isOrderInfo">
        <div v-if="scope.mailType == 9">
          <template v-if="orderInfo.length > 0">
            <div v-if="orderInfo.length > 1">
              <el-button v-for="(item, index) in orderInfo.length" :key="index" type="primary" size="mini"
                @click="getInfo(index)">
                {{ item }}</el-button>
            </div>

            <p>
              订单编号：{{ infoObj.order_id }}
              <el-button type="primary" v-if="isEmail && infoObj.order_id" @click="applyClick()"
                size="mini">发起退款</el-button>
            </p>
            <p>平台订单号：{{ infoObj.platform_order_id }}</p>
            <p>收件人：{{ infoObj.addressee }}</p>
            <p>
              配货状态：{{
                $getText(
                  infoObj.distribution_status,
                  this.dropList.OrderDistributionStatus
                )
              }}
            </p>
            <p>物流跟踪号：{{ infoObj.express_number }}</p>
            <p>物流方式：{{ infoObj.logistics_name }}</p>
            <p>时间：{{ infoObj.delivery_date }}</p>
            <p>最早预计送达时间：{{ infoObj.earliest_arrival_time }}</p>
            <p>最晚预计送达时间：{{ infoObj.latest_arrival_time }}</p>
            <p>订单总价：{{ infoObj.order_amount }}</p>
            <p>账号：{{ infoObj.account_number }}</p>
            <p>
              订单状态：{{
                $getText(infoObj.order_status, this.dropList.OrderOrderStatus)
              }}
            </p>
            <p>币种：{{ infoObj.order_currency }}</p>
            <p style="padding: 5px"></p>
          </template>
          <el-empty v-else description="暂无订单信息"></el-empty>
          <h3>订单明细</h3>
          <commonTable ref="multipleTable" :isExpand="false" :isPage="false" :tableData="infoObj.skuInfo"
            :tableLabel="tableLabel"></commonTable>
        </div>
        <div v-else>
          <template>
            <el-form label-position="right" v-if="this.qaObj != {}">
              <el-form-item label="产品名称：">{{
                qaObj.titleCn
              }}</el-form-item>
              <el-form-item label="产品sku：">{{ qaObj.sku }}</el-form-item>
              <el-form-item label="亚马逊链接：">
                <span class="clickClass" @click="openUrl(qaObj.productUrl)">{{
                  qaObj.productUrl
                }}</span>
              </el-form-item>
              <el-form-item label="价格：">{{ qaObj.newPrice }}</el-form-item>
              <el-form-item label="产品图片："><el-image style="width: 100px; height: 100px" :src="qaObj.productImg[0]"
                  :preview-src-list="qaObj.productImg">
                </el-image></el-form-item>
              <el-form-item>
                <el-button type="primary" @click="huifuClass(qaObj.feedbacklink)">回复</el-button>
              </el-form-item>
            </el-form>
            <el-empty v-else description="暂无订单信息"></el-empty>
          </template>
        </div>
      </div>
    </div>
    <imgView :dialog.sync="isShowImg" :imgList="imgView_msg.list" :imgIndex="imgView_msg.index" :ImgUrl="ImgUrl">
    </imgView>
    <applyRefund v-if="isRefund" @isShowEdit="closeApply" @getList="getDetail" :platform="platform"
      :orderID="infoObj.order_id"></applyRefund>
    <look v-if="lookShow" :scope="lookObj" @isShowEdit="closeApply"></look>
    <el-button v-if="isBottom" @click="toBottom" size="medium" circle class="to-bottom"
      icon="el-icon-caret-bottom"></el-button>
  </div>
</template>
<script>
/**
 * 亚马逊邮件详情/回复页组件
 * 功能：展示邮件正文与附件（图/pdf）、历史邮件切换查询、订单信息与订单明细（可发起退款、查看产品资料）、
 *       回复编辑（模板/翻译/上传附件）、标记邮件、存草稿，进入页面自动置已读
 */
import {
  amazonEmailDetail,
  replyEmail,
  getLanguage,
  saveDrafts,
  singRed,
  translate,
  updateStatus,
  getAmazonMailTitle,
  getAmazonMessageById,
  getAmazonMessageOrder,
  getTemplate
} from "@/api/user";
import imgView from "./imgView";
import applyRefund from "../../afterSale/components/applyRefund";
import look from "./look";
import serverPath from "@/config/config.js";
export default {
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isEmail: {
      // 邮件列表进入详情只能查看不能操作
      type: Boolean,
      default: true,
    },
  },
  components: { imgView, applyRefund, look },
  data() {
    return {
      platform: 1, // 亚马逊平台id
      // 是否打开发起退款弹窗
      isRefund: false,
      // 详情加载状态
      loading: true,
      // 页面整体加载状态
      loadingReply: true,
      // 是否设置为模板（checked == 1 时显示语种/类型选择）
      checked: "",
      test: [],
      content: "",
      // 是否显示回复编辑区（false 时显示翻译区）
      isShow: true,
      // 订单信息加载状态
      isOrderInfo: true,
      // 是否显示返回底部按钮
      isBottom: false,
      // 买家咨询的产品信息（mailType == 3 时展示）
      qaObj: {},
      tableLabel: [
        {
          label: "SKU",
          param: "sku",
          align: "center",
          show: true,
          render: (h, param) => {
            return h(
              "span",
              {
                style: {
                  color: "rgb(64, 158, 255)",
                  cursor: "pointer",
                },
                on: {
                  click: () => {
                    this.lookObj.sku = param.row.sku;
                    this.lookShow = true;
                  },
                },
              },
              param.row.sku
            );
          },
        },
        {
          label: "SKU名称",
          param: "sku_name",
          align: "center",
          show: true,
        },
        {
          label: "订单数量",
          param: "product_quantity",
          align: "center",
          show: true,
        },
      ],
      tableData: [],
      text: "messageId",
      // 附件上传地址
      url: "/crm/yy-attachment/upload/images",
      // 上传成功的图片地址列表
      imgUploadList: [],
      imgName: [], //上传成功的图片名称
      // 上传成功的图片地址（当前未使用）
      imgSrc: [],
      pdfName: [], //上传成功的pdf
      pdfSrc: [],
      // 图片上传成功标记
      isIMg: false,
      // 是否打开图片查看弹窗
      isShowImg: false,
      imgView_msg: {
        show: false, //是否打开图片查看
        index: 0, //图片查看下标
        list: [], //图片列表
      },
      // UploadingUrl: "",
      // 上传附加参数
      uploadObj: {},
      editorOption: {
        placeholder: "编辑文章内容",
      },
      myQuillEditor: {
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              ["blockquote", "code-block"],
              [{ header: 1 }, { header: 2 }],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ script: "sub" }, { script: "super" }],
              [{ indent: "-1" }, { indent: "+1" }],
              [{ direction: "rtl" }],
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ color: [] }, { background: [] }],
              [{ align: [] }],
              ["clean"],
            ],
            handlers: {
              image: this.showUploadDialog,
            },
          },
        },
        placeholder: "请输入邮件信息",
      },
      // htmlText: "",
      // 回复邮件表单数据：发件/收件地址、标题、正文、附件、模板、备注等
      dataObj: {
        // orderNo: "",
        senderAddress: "",
        senderAccount: "",
        recipientAddress: "",
        title: "",
        content: "",
        picture: null,
        templateId: "",
        remark: "",
        temLanguages: "",
        temType: "",
        email: "",
        id: "",
      },
      mailImg: [], // 邮件详情返回的图片
      // 邮件详情返回的 pdf 附件
      mailPdf: [],
      // 订单信息列表（多订单时切换展示）
      orderInfo: [],
      // 当前展示的订单详情
      infoObj: {},
      // 邮件详情数据
      mailObj: {},
      // 翻译结果文本
      newText: "",
      // 语种列表
      languageArr: [],
      // 翻译参数：源语言/目标语言/待翻译文本
      langObj: {
        from: "zh",
        to: "en",
        query: "",
      },
      rules: {
        recipientAddress: [
          { required: true, message: "请输入收件人", trigger: "change" },
          // { validator: isEmailReg, trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "change" }],
        orderId: [
          { required: true, message: "请输入订单编号", trigger: "change" },
        ],
        content: [
          { required: true, message: "请输入邮件内容", trigger: "change" },
        ],
      },
      // 选中的邮件标记类型（重要/待办/垃圾）
      mailTxt: "",
      mailType: [
        { name: "重要邮件", key: "isImportant" },
        { name: "待办邮件", key: "isTodo" },
        { name: "垃圾邮件", key: "isGarbage" },
      ],
      // 历史邮件列表（供切换查询）
      MailList: [],
      // 选中的历史邮件 id
      mailTitle: "",
      // 是否打开产品资料查看弹窗
      lookShow: false,
      // 产品资料弹窗参数（sku）
      lookObj: {},
    };
  },
  computed: {
    // 公共颜色（主题色）
    tabcolors() {
      return this.$store.getters.color;
    },
    htmlText() {
      if (this.scope.htmlText) {
        return this.scope.htmlText;
      } else {
        return this.scope.context;
      }
    },
    templateList() {
      return this.$store.getters.dropList.templateName;
    },
    dropList() {
      return this.$store.getters.dropList;
    },
    ImgUrl() {
      // 图片地址
      const env = serverPath.env;
      if (env === "test" || env === "dev" || env === "localhost") {
        return serverPath.serverPath.server + "/";
      } else {
        return "http://images.delaman168.com/crm/";
      }
    },
  },
  mounted() {
    // 页面挂载时初始化下拉数据、邮件详情与历史邮件列表
    this.init();
    this.getDetail();
    this.getTitle();
  },
  created() {
    // this.$removeStorage("AmazonTitle");
    // 监听页面滚动，用于显示返回底部按钮
    window.addEventListener("scroll", this.watchScroll, true);
  },
  methods: {
    /** 监听滚动位置，超过阈值时显示返回底部按钮 */
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.querySelector(".scroll").scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 20) {
        this.isBottom = true;
      } else {
        this.isBottom = false;
      }
    },
    /** 滚动到页面底部 */
    toBottom() {
      let top = document.querySelector(".scroll").scrollHeight;
      document.querySelector(".scroll").scrollTop = top;
    },
    querySearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      let arr = this.$getStorage("AmazonTitle");
      let newArr = [];
      let results = [];
      if (arr && arr.length > 0) {
        results = arr.filter((item) => {
          return item.value.includes(queryString);
        });
        // 限制最多显示8条
        if (results.length > 8) {
          newArr = results.slice(0, 8);
        } else {
          newArr = results;
        }
      }
      return cb(newArr);
    },

    setIntoStorage(val) {
      let strArr = [];
      if (val && val !== "") {
        strArr.push({
          value: val,
        });
        // 获取已存在的记录
        let history = this.$getStorage("AmazonTitle");
        if (history && history.length > 0) {
          let arr = history.map((item) => item.value);
          if (arr.indexOf(val) > -1) {
            // 判断是否已有此条查询记录，若已存在，则不需再存储
            return;
          }
          // if (history.length >= 5) {
          //   let newArr = this.$getStorage("AmazonTitle");
          //   newArr.pop();
          //   this.$setStorag("AmazonTitle", newArr);
          // }
          //  把搜索记录存入localStorage
          this.$setStorage(
            "AmazonTitle",
            strArr.concat(this.$getStorage("AmazonTitle"))
          );
        } else {
          // 首次创建
          this.$setStorage("AmazonTitle", strArr);
        }
      }
    },
    init() {
      // this.uploadObj.messageId = this.scope.messageId;
      // 调取公共下拉接口
      this.$store.dispatch("getDropListTwo", [
        "templateName",
        "OrderDistributionStatus",
        "OrderOrderStatus",
        "TemplateLanguages",
        "TemplateType",
      ]);
      // 语种
      getLanguage().then((res) => {
        if (res.code === 200) {
          this.languageArr = res.data;
        }
      });
    },
    // 语种交换
    changeSort() {
      const to = this.langObj.to;
      const from = this.langObj.from;
      this.langObj.to = from;
      this.langObj.from = to;
    },
    // 翻译点击
    translation() {
      this.isShow = !this.isShow;
      if (!this.isShow) {
        this.$nextTick(() => {
          this.$refs["textInput"].focus();
        });
      }
      if (this.newText !== "") {
        this.dataObj.content = this.newText;
      }
    },
    // 翻译
    translateClick() {
      this.newText = "正在翻译，请稍等....";
      translate(this.langObj).then((res) => {
        if (res.code === 200) {
          this.newText = res.data;
        }
      });
    },
    // 标记邮件
    markMail() {
      if (this.mailTxt === "") {
        this.$message.warning("请先选择标记类型！");
        return false;
      }
      let param = {
        id: this.dataObj.id,
        [this.mailTxt]: 1,
      };
      updateStatus(param).then((result) => {
        if (result.code == 200) {
          this.$message.success(result.msg);
        }
      });
    },
    // 历史邮件查询
    getTitle() {
      let param = {
        sender: this.scope.sender,
        recipiens: this.scope.recipients,
      };
      this.MailList = [];
      getAmazonMailTitle(param).then((res) => {
        if (res.code === 200) {
          if (res.data.pageInfo && res.data.pageInfo.length > 0) {
            res.data.pageInfo.forEach((item) => {
              this.MailList.push({
                id: item.id,
                title: item.sendDate + " | " + item.subject,
              });
            });
          }
        }
      });
    },
    /**
     * 切换历史邮件时按 id 查询该邮件详情并回填表单
     * @param {String} val 历史邮件 id
     */
    setMailDetail(val) {
      if (val !== "") {
        getAmazonMessageById({ id: val }).then((res) => {
          if (res.code === 200) {
            this.mailObj = res.data;
            this.dataObj.title = this.mailObj.subject;
            this.dataObj.senderAccount = this.mailObj.recipients;
            this.dataObj.recipientAddress = this.mailObj.sender;
            this.dataObj.senderAddress = this.mailObj.recipients;
            this.dataObj.email = this.mailObj.email;
            this.dataObj.id = this.mailObj.id;
          }
        });
      }
    },
    setRed() {
      let param = {
        id: this.scope.id,
        status: 1,
      };
      // 设置邮件已读
      singRed(param).then((result) => {
        if (result.code == 200) {
          // this.$message.success(result.msg);
        }
      });
    },
    getDetail() {
      // 点进详情标记为已读（草稿箱列表除外）
      if (this.emailType !== "drafts") {
        this.setRed();
      }
      let obj = {
        messageId: this.scope.messageId,
        email: this.scope.sender,
      };
      // 调详情接口
      amazonEmailDetail(obj).then((res) => {
        if (res.code === 200) {
          this.loading = false;
          this.loadingReply = false;
          this.mailObj = res.data.yyAmazonMessage;

          // this.dataObj.content = this.content;
          this.dataObj.title = this.mailObj.subject;
          this.dataObj.senderAccount = this.mailObj.recipients;
          this.dataObj.recipientAddress = this.mailObj.sender;
          this.dataObj.senderAddress = this.mailObj.recipients;
          this.dataObj.email = this.mailObj.email;
          this.dataObj.id = this.mailObj.id;
          this.isIMg = true;
          const newArr = res.data.yyAttachment || [];
          // this.mailImg = res.data.yyAttachment;
          newArr.forEach((item) => {
            if (this.isImageAttachment(item)) {
              this.mailImg.push(item.attachmentPath);
            } else {
              this.mailPdf.push(item);
            }
          });
        }
      });
      if (this.scope.mailType == 9 || this.scope.mailType == 3) {
        let param = {
          mailType: this.scope.mailType,
          sender: this.scope.mailType == 3 ? this.scope.id : this.scope.sender,
        };
        this.isOrderInfo = true;
        getAmazonMessageOrder(param).then((res) => {
          if (res.code === 200) {
            this.isOrderInfo = false;
            // 订单信息
            if (this.scope.mailType == 9) {
              this.orderInfo = res.data.amazonOrderVO;
              this.infoObj = this.orderInfo[0] ? this.orderInfo[0] : "";
            } else {
              this.qaObj = res.data;
            }
          }
        });
      }
    },
    // 关闭弹窗
    closeApply() {
      this.isRefund = false;
      this.lookShow = false;
    },
    /** 打开发起退款弹窗 */
    applyClick() {
      this.isRefund = true;
    },
    getInfo(index) {
      // 自制小型分页-订单信息
      this.infoObj = this.orderInfo[index];
    },
    /** 选择模板时按模板名查询内容并填充正文 */
    changeTemplate(value) {

      getTemplate({ name: value }).then((res) => {
        if (res.code === 200) {
          this.dataObj.content = res.data;
        }
      });

      // 选择模板
      // this.templateList.forEach((element) => {
      //   if (element.id == value) {
      //     this.dataObj.content = element.content;
      //     this.$refs.myQuillEditor.quill.focus();
      //   }
      // });
    },
    /** 判断附件是否为浏览器可直接预览的图片 */
    isImageAttachment(item) {
      const fileName = item.attachmentName || item.messageCid || "";
      const extension = fileName.split(".").pop().toLowerCase();
      return [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "webp",
        "bmp",
        "svg",
        "ico",
        "avif",
      ].includes(extension);
    },
    /** 新窗口打开非图片附件 */
    toTab(val) {
      window.open(val.attachmentPath, "_blank");
    },
    // 移除已上传附件
    handleDel(index) {
      this.imgName.splice(index, 1);
      this.imgSrc.splice(index, 1);
      this.dataObj.picture.splice(index, 1);
    },
    /** 关闭页面并通知父组件刷新列表 */
    close() {
      this.$emit("isShowEdit");
      this.$emit("getList");
    },
    setContent() {
      // 聚焦
      this.$refs.myQuillEditor.quill.focus();
    },
    // 回复邮件
    send() {
      this.dataObj.messageId = this.scope.messageId;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          replyEmail(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message.success("发送成功");
              this.dataObj.content = "";
              this.close();
            }
          });
        }
      });
    },
    // 存草稿
    saveSlide() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          saveDrafts(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message.success("保存成功");
              this.dataObj.content = "";
            }
          });
        }
      });
    },
    // 获取上传图片成功后图片名称
    getImgName(val) {
      val.forEach((item) => {
        // this.imgName.push(item);
      });
      this.isIMg = true;
    },
    getImgSrc(val) {
      // 获取图片地址
      val.forEach((item) => {
        this.imgUploadList.push(item.urlList);
        if (item.fileList.split(".")[1] == "pdf") {
          this.pdfSrc.push(item);
        } else {
          this.imgName.push(item);
          this.imgView_msg.list.push(item.urlList);
        }
      });
      this.dataObj.picture = this.imgUploadList;
    },
    /** 新窗口打开 pdf 附件预览 */
    seePdf(item) {
      window.open(this.ImgUrl + item.urlList, "_blank");
    },
    // 查看大图
    seeImg(index) {
      this.imgView_msg.index = index;
      this.isShowImg = true;
    },
    /** 新窗口打开外部链接（亚马逊产品链接） */
    openUrl(value) {
      window.open(value, "_blank");
    },
    /** 移除已上传的 pdf 附件（删除图片列表时引用未定义变量 item，存在报错隐患） */
    handleDelPdf(index) {
      this.pdfSrc.splice(index, 1);
      this.dataObj.picture.splice(item.urlList, 1);
    },
    /** 新窗口打开中差评回复链接 */
    huifuClass(value) {
      window.open(value, "_blank");
    },
  },
};
</script>
<style lang="scss">
.padding10px {
  padding: 10px !important;
}

.toText-css {
  margin-top: 7px;
  margin-bottom: 5px;
  text-align: center;
  width: 40px;
  display: inline-block;
  cursor: pointer;
  transform: rotate(90deg);
}

.replay-div {
  display: flex;
  align-items: flex-start;

  .order-box {
    border: 1px solid #ebeef5;
    border-radius: 10px;
    padding: 10px;
  }

  .mail-detail {
    width: 70%;
    margin-right: 30px;

    .border-box {
      border: 1px solid #ebeef5;
      border-radius: 10px;
      padding: 10px;
      // width: 100%;
      margin-bottom: 20px;
    }
  }

  .order-box {
    width: 25%;

    p {
      font-size: 14px;
      color: #333333;
      line-height: 30px;
    }
  }

  .sort-css {
    margin-bottom: 5px;
    text-align: center;
    width: 130px;
    cursor: pointer;
  }

  .tag-annex {
    margin-right: 20px;
    cursor: pointer;
  }
}

.border-box a {
  pointer-events: none !important;
}

.webkit>a {
  pointer-events: none !important;
}

center a {
  pointer-events: none !important;
}

.clickClass {
  cursor: pointer;
  color: #409eff;
}
</style>
